export default __webpack_public_path__ + "static/media/Ramaiah.40bcde53.png";